import { Tour } from "nextstepjs";

const flyerGuide: Tour[] = [
  {
    tour: "flyerTour",
    steps: [
      {
        icon: "",
        title: "",
        content:
          "Easily toggle between Flyer PDF view and Flyer List view to customize your shopping experience.",
        selector: "#flyer_list_view",
        side: "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 3,
        pointerRadius: 10,
      },
    ],
  },
];

export default flyerGuide;
